import { render, staticRenderFns } from "./MobileStockItem.vue?vue&type=template&id=5e0223be&scoped=true"
import script from "./MobileStockItem.vue?vue&type=script&lang=js"
export * from "./MobileStockItem.vue?vue&type=script&lang=js"
import style0 from "./MobileStockItem.vue?vue&type=style&index=0&id=5e0223be&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0223be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e0223be')) {
      api.createRecord('5e0223be', component.options)
    } else {
      api.reload('5e0223be', component.options)
    }
    module.hot.accept("./MobileStockItem.vue?vue&type=template&id=5e0223be&scoped=true", function () {
      api.rerender('5e0223be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/components/MobileStockItem.vue"
export default component.exports